<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="precen"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="cnfprecen" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>

<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar"
            [botonBorrar]="btnBorrar" [botonRegresar]="false" [barraBotonesDesplaz]="true" [barraBotones3]="true"
            [barraBotonesAsiCon]="true" [barraBotones5]="true" [botonconsolida]="false" [botonBuscarPermanente]="true"
            [botonImprimirPermanente]="true"></app-invmaebarra>
    </div>
</div>
<div class="p-col-12">
    <p-tabView [(activeIndex)]="index" (activeIndexChange)="cambioTab()">
        <p-tabPanel header="Presupuesto Por centro de costos">
        <div class="contorno" id="contorno">
            <div class="divgrups">
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Fecha Inicio:</span>
                            </div>
                            <div class="p-col-1">
                                <p-calendar id="ENCPRECEN_FECHAINI" [inputStyle]="{width: '100%', height: '20px'}"
                                    [(ngModel)]="conprecenService.encprecen[indicador].ENCPRECEN_FECHAINI"
                                    [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                    (keydown)="botonesmodificar()">
                                </p-calendar>
                            </div>
                            <div class="p-col-1">
                                <span>Fecha Fin:</span>
                            </div>
                            <div class="p-col-1">
                                <p-calendar id="ENCPRECEN_FECHAFIN" [inputStyle]="{width: '100%', height: '20px'}"
                                    [(ngModel)]="conprecenService.encprecen[indicador].ENCPRECEN_FECHAFIN"
                                    [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                    (keydown)="botonesmodificar()">
                                </p-calendar>
                            </div>

                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Cliente:</span>
                            </div>
                            <div class="p-col-1">
                                <label for="CLI_CODIGO"></label>
                                <input class="frm" id="CLI_CODIGO" type="text" pInputText 
                                    [(ngModel)]="conprecenService.encprecen[indicador].CLI_CODIGO"
                                    (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                    autocomplete="off">
                            </div>
                            <div class="p-col-1">
                                <button type="button"
                                    style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                    (click)="busquedacliente(conprecenService.encprecen[indicador].CLI_CODIGO)"></button>
                            </div>
                            <div class="p-col-3">
                                <label for="CLI_NOMBRE"></label>
                                <input class="frm" id="CLI_NOMBRE" type="text" pInputText disabled
                                    style="color: blue;"
                                    [(ngModel)]="conprecenService.encprecen[indicador].CLI_NOMBRE"
                                    autocomplete="off">
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Descripción:</span>
                            </div>
                            <div class="p-col-11">
                                <input pInputText type="text" size="14" id="ENCPRECEN_DESCRIPCION"
                                    (keydown.enter)="setFocus($event)"
                                    [(ngModel)]="conprecenService.encprecen[indicador].ENCPRECEN_DESCRIPCION" autocomplete="off"
                                    (input)="botonesmodificar()" [maxLength]="100">
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>C.costos:</span>
                            </div>
                            <div class="p-col-3">
                                <input type="text" pInputText style="width: 100%" id="CEN_CODIGO"
                                    (keydown.enter)="setFocus($event)" (input)="botonesmodificar()"
                                    [(ngModel)]="conprecenService.encprecen[indicador].CEN_CODIGO" autocomplete="off">
                            </div>
                            <div class="p-col-1">
                                <button type="button"
                                    style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                    class="littlebuttons" (click)="busquedaCentroCostos(conprecenService.encprecen[indicador].CEN_CODIGO)"></button>
                            </div>
                            <div class="p-col-3">
                                <label for="CEN_NOMBRE"></label>
                                <input class="frm" id="CEN_NOMBRE" type="text" pInputText disabled
                                    style="color: blue;"
                                    [(ngModel)]="conprecenService.encprecen[indicador].CEN_NOMBRE"
                                    autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="divg" style="height: 650px">
                <!-- <app-aggridsaci [width]="" [height]="200" [enableSorting]="false" [enableFilter]="true"
                    [rowData]="conprecenService.detprecen" [frameworkComponents]="frameworkComponents"
                    [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsprecen"
                    [defaultColDef]="defaultColDefPrecen" [rowStyle]="rowStyle" [singleClickEdit]="false"
                    [botones]="true" (selected)="selectedPrecen($event)" (cambios)="botonesmodificar()">
                </app-aggridsaci> -->

                <app-aggridsaci [width]="" [height]="200" [enableSorting]="false" [enableFilter]="true"
				[rowData]="conprecenService.detprecen[indicador]" [frameworkComponents]="frameworkComponents"
				[animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsprecen"
				[defaultColDef]="defaultColDefPrecen" [rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true"
				[mostrarGuardar]="false" (cambios)="botonesmodificar()" [botonNuevo]="btnNuevoGrid"
                 [botonBorrar]="btnBorrarGrid" [botonRegresar]="btnCancelarGrid" [tipodetalle]="tipodetalle"
                [comboOpciones]="comboOpciones" (rdbtipodet)="cambiarTipo($event)"
				(selected)="selectedPrecen($event)"
				></app-aggridsaci>
            </div>
        </p-tabPanel>

    </p-tabView>
</div>
<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
    [consulta]="consulta"
        [busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<p-dialog header="Reportes" [(visible)]="displayDialogReportes" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '40vw', height: '400px'}">
	<app-sacimaecfngimpr [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
		[strNumDoc]="conprecenService.encprecen[indicador].ENCPRECEN_NUMERO" [strCampo]="'ENCPRECEN_NUMERO'"
		[botonExcel]="true"
		(cerrar)="cerrarReportes()"></app-sacimaecfngimpr>
</p-dialog>
<p-dialog header="Código de seguridad" [(visible)]="displayToken" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [closable]="true" [showHeader]="true">
	<p-toast [style]="{marginTop: '35vh'}" position="top-center" key="prodUsuToken"></p-toast>
	<div style="background-color: rgb(235,245,251); padding: 1.5em;">
		<div class="p-col-12" style="text-align: center">
			<input style="font-size: 25pt; width: 150px; height: 60px;" type="password" [(ngModel)]="tokenusuario"
				(keydown)="enterToken($event)" pInputText autocomplete="off">
		</div>
		<div class="p-col-12" style="text-align: center">
			<div class="p-grid">
				<div class="p-col-6" style="text-align: center">
					<button class="aceptar" (click)="aceptarToken()" pButton type="button" icon="pi pi-user"
						label="Aceptar"></button>
				</div>
				<div class="p-col-6" style="text-align: center">
					<button class="aceptar" (click)="cancelarToken()" pButton type="button" icon="pi pi-undo"
						label="Cancelar"></button>
				</div>
			</div>
		</div>
	</div>
</p-dialog>
<div style="position: fixed;
			z-index: 999;
			height: 2em;
			width: 2em;
			overflow: visible;
			margin: auto;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;">
	<p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
	</p-progressSpinner>
</div>